import script from "./deletedDevice.vue?vue&type=script&setup=true&lang=js"
export * from "./deletedDevice.vue?vue&type=script&setup=true&lang=js"

import "./deletedDevice.vue?vue&type=style&index=0&id=48ff9276&lang=scss&scoped=true"

import exportComponent from "D:\\liu\\jmzc\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48ff9276"]])

export default __exports__